<template>
    <Content style="background:rgba(249,249,249,1);">
        <div class="bg"></div>
        <div class="tabs-wrap-news">
            <ul class="nav-tabs">
                <li class="tab-item" @click="selectTab(index,item.categoryId)" :class="{active:currentTabIndex==index}" v-for="(item,index) in tabs" :key="index">{{item.title}}</li>
            </ul>
            <ul class="tabs-content">
                <li>
                    <dl v-for="(list,index) in newLists" :key="index"  @click="more(list.newsId)">
                        <dt v-show="list.picUrl"><img :src="list.picUrl"></dt>
                        <dd>
                            <span>{{list.title}}</span>
                            <span class="pub">{{list.publishTime}}</span>
                            <p>{{list.summary}}</p>
                            <a class="More" @click="more(list.newsId)">查看更多 →</a>
                        </dd>
                    </dl>
                    <div class="no-data" v-if="newLists.length==0" >暂时没有数据</div>
                    <Page :total="total" :page-size="pageInfo.pageSize" show-total style="margin-top: 10px;" @on-change="pageChange"  />
                </li>
            </ul>
        </div>
    </Content>
</template>

<script>
    import api from '@/api/api'

    export default {
        name: 'news',
        data (){
          return{
              currentTabIndex:0,
              categoryId:'',
              tabs:[],
              newLists:[],
              total:0,
              pageInfo:{
                  page:0,
                  pageSize:12
              }
          }
        },
        activated(){
            this.getNewsCategory();
        },
        methods:{
            pageChange(index){
                this.pageInfo.page = index-1
                this.getNewsCategory()
            },
            getNewsCategory(){
              var _this = this;
              api.newsCategory().then(res => {
                  _this.tabs = res;
                  _this.categoryId = res[0].categoryId;
                  let data = {
                      page:_this.pageInfo.page,
                      pageSize:_this.pageInfo.pageSize,
                      categoryId:_this.categoryId
                  }
                  api.newsList(data).then(res => {
                      _this.newLists = res.rows;
                      _this.total = res.total;
                  }).catch(error => {
                      this.$Message.error('列表数据获取错误')
                  });
              }).catch(error =>{
                  this.$Message.error('分类数据获取错误')
              });
            },
            selectTab(index,categoryId){
                var _this = this;
                this.currentTabIndex = index;
                let data = {
                    page:_this.pageInfo.page,
                    pageSize:_this.pageInfo.pageSize,
                    categoryId:categoryId
                }
                api.newsList(data).then(res => {
                    _this.newLists = res.rows;
                    _this.total = res.total;
                }).catch(error => {
                    this.$Message.error('列表数据获取错误')
                });
            },
            more(newsId){
                this.$router.push({
                    name: 'newsDetail', params: {newsId: newsId}
                })
            }
        },
        components: {}
    }
</script>

<style scoped lang="scss">
    .layout {
        background: #f5f7f9;
        position: relative;
        overflow: hidden;
    }

    .bg {
        width: 100%;
        height: 280px;
        background: url("../../assets/bannner3.png") no-repeat center;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
    }

    .tabs-wrap-news{
        margin: 30px auto;
        .nav-tabs{
            overflow: hidden;
            display: inline-block;
            .tab-item{
                float: left;
                width: 184px;
                height: 50px;
                line-height: 50px;
                font-size: 18px;
                border: 1px solid #ccc;
                &:hover{
                     background-color: #009de952;
                     color: #fff;
                     border-color: #009de952;
                     cursor: pointer;
                }
                &.active{
                     background-color: #009DE9;
                     color: #fff;
                     border-color: #009DE9;
                }
            }
        }
        .tabs-content{
            dl {
                border-bottom: 1px solid rgba(230,230,230,1);
                width: 70%;
                padding-bottom: 15px;
                margin: 30px auto;
                text-align: left;
                dt {
                    width: 15%;
                    padding: 18px;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    float: left;
                    img {
                        width: 100%;
                    }
                }
                dd {
                    padding: 18px;
                    text-align: left;
                    font-size:16px;
                    font-family:MicrosoftYaHei;
                    font-weight:400;
                    span {
                        font-size: 1.25em;
                        color:rgba(51,51,51,1);
                        text-align: left;
                    }
                    span.pub {
                        float: right;
                        font-size:16px;
                        color:rgba(102,102,102,1);
                    }
                    p {
                        color:rgba(102,102,102,1);
                        line-height:30px;
                        margin-top: 25px;
                    }
                    .More {
                        float: right;
                        margin-top: 5px;
                    }
                }

            }
        }
        .no-data{
            font-size: 24px;
        }
    }
</style>
